import { render, staticRenderFns } from "./fangjia.vue?vue&type=template&id=84c4020e&"
import script from "./fangjia.vue?vue&type=script&lang=js&"
export * from "./fangjia.vue?vue&type=script&lang=js&"
import style0 from "./fangjia.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports